import { Injectable } from '@angular/core';
import { UserInfoService, } from '../../http';
import { ApiRequestService } from '../../http';
import { CommonUtilty } from '../../utilities';
import { DataTransformService } from 'app/ViewModules/shared-services';
import { AppMetadataHandler } from 'app/BaseFramework/configs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PersonalisedInobxService {
  inboxDataPointsDefaultSet: any = [];
  inboxDataPointsSuperSet: any = [];

  constructor(
    private userInfoService: UserInfoService,
    public appMetadataHandler: AppMetadataHandler,
    private message: NzMessageService,
    public commonUtilty: CommonUtilty,
    public dataTransFormService: DataTransformService,
    public apiRequestService: ApiRequestService
  ) { }

 
  // inboxCardCfgFetchByGuid
  // inboxCardCfgFetchByEntityCdAndLob
  // inboxCardCfgFetchByEntityCdAndLobAndRoleCd
  // inboxCardCfgFetchByEntityCdAndLobAndRoleCdAndServiceTaskCd
  // inboxCardCfgFetchByEntityCdAndLobAndRoleCdAndServiceTaskCdAndUserId
   
  
   
  // inboxCardCfg/fetchByGuid
  // inboxCardCfg/fetch/${entityCd}/${lob}
  // inboxCardCfg/fetch/${entityCd}/${lob}/${roleCd}
  // inboxCardCfg/fetch/${entityCd}/${lob}/${roleCd}/${serviceTaskCd}
  // inboxCardCfg/fetch/${entityCd}/${lob}/${roleCd}/${serviceTaskCd}/${userId}
   
   
   
  personalisedInboxJson : any
fetchPersonalizedData(privilegeCd): Observable<any>{
  let userId = this.userInfoService.getUserId();
  let parameters = [userId, privilegeCd]
  let fetchInboxDetails = new Subject<any>();
  let url = `appMenuConfigFetchByUserAndPrivilege`;  // Update the API endpoint
  this.apiRequestService.getCallWithAPIMapper(url, null, null, parameters).subscribe(
    (res: any) => {
      if(res && res.menuDataList) this.setFieldKeyValue(res.menuDataList)
      fetchInboxDetails.next(res);
      if(res && res.menuDataList){
      this.personalisedInboxJson = res;
      this.mapApiDataToFields();
      }
    },
    (error) => {
      fetchInboxDetails.next(error);
      // this.message.warning('Unable to fetch personalized inbox details.');
    }
  );
  return fetchInboxDetails;
}

mapApiDataToFields() {
  if(this.personalisedInboxJson && this.personalisedInboxJson.menuDataList && this.commonUtilty.isArrayIterable(this.personalisedInboxJson.menuDataList) && this.personalisedInboxJson.menuDataList.length){
    this.inboxDataPointsDefaultSet= this.personalisedInboxJson.menuDataList.filter(item => item.isVisible);
  }
  // Filter and push items to inboxDataPointsDefaultSet based on isVisible property
  this.inboxDataPointsSuperSet = this.personalisedInboxJson.menuDataList.filter(item => !item.isVisible);
}

setFieldKeyValue(fetchInboxDetails){
  if(fetchInboxDetails && fetchInboxDetails.length){
    fetchInboxDetails.forEach(field => {
      if(field['keyData']) field['key'] = field['keyData']
    })
  }
  return fetchInboxDetails;
}

savePersonalizedDetails(payload) {
  let url = `inboxCardCfgSave`;
  let userId = this.userInfoService.getUserId();
  let cardFields = this.commonUtilty.deepCopy(payload);

  let savedInboxDetails = new Subject<any>();
  this.apiRequestService.postCallWithAPIMapper(url, payload).subscribe(
    (res: any) => {
      savedInboxDetails.next(res);
      this.personalisedInboxJson = res;
      // this.mapApiDataToFields();
    },
    (error) => {
      savedInboxDetails.next(error);
      this.message.error('Unable to save personalized inbox details.');
    }
  );
  return savedInboxDetails;
}
submitPersonalizedDetails(payload) {
  let url = `inboxCardCfgSubmit`;
  let userId = this.userInfoService.getUserId();
  let cardFields = this.commonUtilty.deepCopy(payload);

  let savedInboxDetails = new Subject<any>();
  this.apiRequestService.postCallWithAPIMapper(url, payload).subscribe(
    (res: any) => {
      savedInboxDetails.next(res);
      this.personalisedInboxJson = res;
      // this.mapApiDataToFields();
    },
    (error) => {
      savedInboxDetails.next(error);
      this.message.error('Unable to save personalized inbox details.');
    }
  );
  return savedInboxDetails;
}

  fetchPersonalizedDataBasedOnEntityLOB(entityCd,LOB): Observable<any>{
    let userId = this.userInfoService.getUserId();
    let parameters = [entityCd, LOB]
    let fetchInboxDetails = new Subject<any>();
    let url = `inboxCardCfgFetchByEntityCdAndLob`;  // Update the API endpoint
    this.apiRequestService.getCallWithAPIMapper(url, null, null, parameters).subscribe(
      (res: any) => {
        console.log("Entty and LOB data", res)
        // if(res && res.menuDataList) this.setFieldKeyValue(res.menuDataList)
        fetchInboxDetails.next(res);
        // if(res && res.menuDataList){
        // this.personalisedInboxJson = res;
        // this.mapApiDataToFields();
        // }
      },
      (error) => {
        fetchInboxDetails.next(error);
        // this.message.warning('Unable to fetch personalized inbox details.');
      }
    );
    return fetchInboxDetails;
  }
  fetchPersonalizedDataBasedOnRoleCdServiceTaskCd(serviceTask): Observable<any>{
    let roleCd = this.userInfoService.getUserRoleDO().roleId;
    let parameters = [roleCd,serviceTask]
    let fetchInboxDetails = new Subject<any>();
    let url = `inboxCardCfgFetchByRoleCdServiceTaskCd`;  // Update the API endpoint
    this.apiRequestService.getCallWithAPIMapper(url, null, null, parameters).subscribe(
      (res: any) => {
        console.log("Entity,LOB,serviceTask data", res)
        // if(res && res.menuDataList) this.setFieldKeyValue(res.menuDataList)
        fetchInboxDetails.next(res);
        // if(res && res.menuDataList){
        // this.personalisedInboxJson = res;
        // this.mapApiDataToFields();
        // }
      },
      (error) => {
        fetchInboxDetails.next(error);
        // this.message.warning('Unable to fetch personalized inbox details.');
      }
    );
    return fetchInboxDetails;
  }
  fetchPersonalizedDataBasedOnEntityRoleCdServiceTask_old(entityCd,serviceTask): Observable<any>{
    let roleCd = this.userInfoService.getUserRoleDO().roleId;
   let parameters = [entityCd, roleCd,serviceTask]
    let fetchInboxDetails = new Subject<any>();
    let url = `inboxCardCfgFetchByEntityCdAndRoleCdAndServiceTaskCd`;  // Update the API endpoint
    this.apiRequestService.getCallWithAPIMapper(url, null, null, parameters).subscribe(
      (res: any) => {
        console.log("Entity,LOB,servicetAsk and role data", res)
        fetchInboxDetails.next(res);
      },
      (error) => {
        fetchInboxDetails.next(error);
        // this.message.warning('Unable to fetch personalized inbox details.');
      }
    );
    return fetchInboxDetails;
  }
  fetchPersonalizedDataBasedOnEntityRoleCdServiceTaskUserId_old(entityCd,serviceTask): Observable<any>{
    let roleCd = this.userInfoService.getUserRoleDO().roleId;
    let userId = this.userInfoService.getUserId();
   let parameters = [entityCd,serviceTask,userId]
    let fetchInboxDetails = new Subject<any>();
    let url = `inboxCardCfgFetchByEntityCdAndServiceTaskCdAndUserId`;  // Update the API endpoint
    this.apiRequestService.getCallWithAPIMapper(url, null, null, parameters).subscribe(
      (res: any) => {
        console.log("Entity,LOB,servicetAsk and role data", res)
        fetchInboxDetails.next(res);
      },
      (error) => {
        fetchInboxDetails.next(error);
        // this.message.warning('Unable to fetch personalized inbox details.');
      }
    );
    return fetchInboxDetails;
  }
  fetchPersonalizedDataBasedOnEntityRoleCdServiceTask(entityCd, serviceTask): Observable<any> {
    let roleCd = this.userInfoService.getUserRoleDO().roleId;
    let parameters = [entityCd, roleCd, serviceTask];
    let url = `inboxCardCfgFetchByEntityCdAndRoleCdAndServiceTaskCd`;
  
    return new Observable((observer) => {
      this.apiRequestService.getCallWithAPIMapper(url, null, null, parameters).subscribe(
        (res: any) => {
          console.log("Entity, LOB, serviceTask, and role data", res);
          observer.next(res);
          observer.complete(); // Ensure observable completes
        },
        (error) => {
          console.error("Error fetching data:", error);
          observer.error(error);
          observer.complete(); // Ensures forkJoin doesn't hang
        }
      );
    });
  }
  
  fetchPersonalizedDataBasedOnEntityRoleCdServiceTaskUserId(entityCd, serviceTask): Observable<any> {
    let roleCd = this.userInfoService.getUserRoleDO().roleId;
    let userId = this.userInfoService.getUserId();
    let parameters = [entityCd, serviceTask, userId];
    let url = `inboxCardCfgFetchByEntityCdAndServiceTaskCdAndUserId`;
  
    return new Observable((observer) => {
      this.apiRequestService.getCallWithAPIMapper(url, null, null, parameters).subscribe(
        (res: any) => {
          console.log("Entity, LOB, serviceTask, and user data", res);
          observer.next(res);
          observer.complete(); // Ensure observable completes
        },
        (error) => {
          console.error("Error fetching user data:", error);
          observer.error(error);
          observer.complete(); // Ensures forkJoin doesn't hang
        }
      );
    });
  }
  
  fetchPersonalizedDataBasedOnServicetaskUserId(serviceTask): Observable<any>{
    let roleCd = this.userInfoService.getUserRoleDO().roleId;
    let userId = this.userInfoService.getUserId();
    let parameters = [serviceTask,userId]
    let fetchInboxDetails = new Subject<any>();
    let url = `inboxCardCfgFetchByServiceTaskCdAndUserId`;  // Update the API endpoint
    this.apiRequestService.getCallWithAPIMapper(url, null, null, parameters).subscribe(
      (res: any) => {
        console.log("Entity,LOB,serviceTask,role and user ID data", res)
        // if(res && res.menuDataList) this.setFieldKeyValue(res.menuDataList)
        fetchInboxDetails.next(res);
        // if(res && res.menuDataList){
        // this.personalisedInboxJson = res;
        // this.mapApiDataToFields();
        // }
      },
      (error) => {
        fetchInboxDetails.next(error);
        // this.message.warning('Unable to fetch personalized inbox details.');
      }
    );
    return fetchInboxDetails;
  }
}
